import { getWordingWithDots } from '@myre/common-i18n';

import { Injectable } from '@angular/core';
import {
  TranslateStore,
  type InterpolatableTranslation,
  type Language,
} from '@ngx-translate/core';

@Injectable()
export class MyreTranslateStore extends TranslateStore {
  protected override getValue(
    language: Language,
    key: string,
  ): InterpolatableTranslation {
    const translations = this.getTranslations(language);

    if (!translations) {
      return;
    }

    return getWordingWithDots(key, translations) as InterpolatableTranslation;
  }
}
